import { render, staticRenderFns } from "./ImportPaxItemsPopup.vue?vue&type=template&id=2eec55ca&scoped=true&"
import script from "./ImportPaxItemsPopup.vue?vue&type=script&lang=js&"
export * from "./ImportPaxItemsPopup.vue?vue&type=script&lang=js&"
import style0 from "./ImportPaxItemsPopup.vue?vue&type=style&index=0&id=2eec55ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec55ca",
  null
  
)

export default component.exports